import type { TMessages } from '@/types/TMessages'

export const messages = {
  expand: 'Развернуть',
  collapse: 'Свернуть',
} as const satisfies TMessages
